module.exports = __webpack_public_path__ + "static/media/graham.0d6f1aef.gif";